export default {
  companySettings: [],
  companySetting: undefined,
  availableSettings: [
    { name: 'Non Recurring Invoices: Generate Pro-Rata for any upgrade', value: 'invoices/nrc/pro-rata' },
    { name: 'Monthly Recurring Invoices: Generate Pro-Rata for any upgrade', value: 'invoices/mrc/pro-rata' },
    { name: 'Journals: Generate pre-invoiced journals for all invoices', value: 'journals/invoices' },
  ],
};
